import type React from 'react';

export const inputBase = "w-full rounded-[10px] border border-hairline bg-white text-body text-ink outline-none transition-colors";

export function inputStyle(): React.CSSProperties {
  return { padding: "13px 14px", fontFamily: "inherit", boxSizing: "border-box" };
}
